import { BadgeCheck, BookmarkCheck, ShieldCheck } from 'lucide-react';

export const WorkingSince = () => {
  return (
    <div className="flex w-full justify-center bg-[#121212] py-[4rem] font-inter">
      <div className="flex w-full max-w-[144rem] flex-row flex-wrap items-center justify-center gap-y-[3rem] px-[2rem]">
        <div className="flex w-full items-center gap-[2rem] md:w-[50%]">
          <BadgeCheck className="h-auto w-[12rem] text-[#e24e1f] lg:w-[16.4rem]" />
          <div>
            <h1 className="text-[3.2rem] font-[700] leading-[4rem] text-[#FFFFFF] lg:text-[4rem] lg:leading-[5.5rem]">
              Building Trust <br /> Since 2023
            </h1>
            {/* <p className="mt-[1rem] max-w-[40rem] text-[1.6rem] font-[400] leading-[3.2rem] text-[#DDDDDD]">
              Delivering trusted construction, renovation, and infrastructure solutions across the
              UK — KU Contractors brings decades of expertise, precision, and reliability to every
              project.{' '}
            </p> */}
          </div>
        </div>
        <div className="w-full max-w-[40rem] text-center md:w-[50%] md:text-start">
          {' '}
          <p className="text-[1.6rem] font-[400] leading-[3.2rem] text-[#DDDDDD]">
            At <strong>KU Contractors Limited</strong>, we take pride in every project — big or
            small. Since 2023, our mission has been simple: to deliver dependable craftsmanship,
            transparent service, and long-lasting results. From quick repairs to full-scale
            renovations, we’ve built our reputation on quality work and satisfied
            clients across the UK.
          </p>
        </div>
        <div className="mt-[3rem] flex w-full flex-wrap items-stretch justify-between gap-y-[2rem]">
          <div className="flex w-full items-start justify-between rounded-[1rem] bg-[#1C253C] px-[2rem] py-[2rem] md:w-[33%]">
            <BookmarkCheck className="h-auto w-[4rem] text-[#e24e1f]" />
            <div className="w-[calc(100%-5rem)]">
              <p className="text-[2rem] font-[600] text-[#DDDDDD]">10% Off on Home Renovations</p>
              <p className="mt-[1rem] text-[1.6rem] font-[400] text-[#DDDDDD]">
                Enjoy exclusive discounts on your next renovation or remodeling project. Quality
                work at the best value.
              </p>
            </div>
          </div>
          <div className="flex w-full items-start justify-between rounded-[1rem] bg-[#1C253C] px-[2rem] py-[2rem] md:w-[33%]">
            <BookmarkCheck className="h-auto w-[4rem] text-[#e24e1f]" />
            <div className="w-[calc(100%-5rem)]">
              <p className="text-[2rem] font-[600] text-[#DDDDDD]">Free Site Consultation</p>
              <p className="mt-[1rem] text-[1.6rem] font-[400] text-[#DDDDDD]">
                Schedule a complimentary site visit and cost estimation no obligations, just expert
                advice
              </p>
            </div>
          </div>
          <div className="flex w-full items-start justify-between rounded-[1rem] bg-[#1C253C] px-[2rem] py-[2rem] md:w-[33%]">
            <ShieldCheck className="h-auto w-[4rem] text-[#e24e1f]" />
            <div className="w-[calc(100%-5rem)]">
              <p className="text-[2rem] font-[600] text-[#DDDDDD]">5-Year Structural Warranty</p>
              <p className="mt-[1rem] text-[1.6rem] font-[400] text-[#DDDDDD]">
                Every project we complete is backed by a 5-year structural guarantee for your peace
                of mind.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
